module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-main-banner-d7f5e3a757fbbcb659cae95994d5de62.jpg";